export default __webpack_public_path__ + "static/media/productList2.e4739e36.png";